module.exports = __webpack_public_path__ + "static/media/available-soon.5a7580ce.jpg";